import { render, staticRenderFns } from "./Vorschau.vue?vue&type=template&id=b3fd4d12&scoped=true"
import script from "./Vorschau.vue?vue&type=script&lang=js"
export * from "./Vorschau.vue?vue&type=script&lang=js"
import style0 from "./Vorschau.vue?vue&type=style&index=0&id=b3fd4d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fd4d12",
  null
  
)

export default component.exports